import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/early-years/layoutProps';

import image from './staff@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="staff">
    <h1>Staff at KIK/KCC</h1>
    <p>
      Our international teaching team is a cornerstone of our programme. Our teachers come from countries such as
      America, Australia, China, Hong Kong, New Zealand, South Africa,and the United Kingdom. All class teachers are
      native speakers of either English or Putonghua. All of our teachers are fully qualified to deliver high quality
      Early Childhood Education to our students. As a school we are fully committed to ongoing professional development
      and provide opportunities for all our staff to attend IBPYP workshops as well as other relevant professional
      learning opportunities.
    </p>
    <img src={image} alt="Staff at KIK/KCC" />
  </ContentLayout>
);
